/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { classNames } from '../../utils/classNames';
import {
    extraNavigation,
} from '../../utils/navigation-constants/navigation-partner';

interface INavigation {
    search?: string
    onItemClick?: () => void;
}

const Navigation = ({
    search,
    onItemClick,
}: INavigation) => {
    const location = useLocation();
    const [navigationPartnerExtra] = useState<any>(extraNavigation)
    const [loading] = useState<boolean>(false)

    return (
        <div className='flex flex-col min-h-[100%] justify-between'>
            <>
                <div className='mb-1 pt-2'>
                    {!loading && navigationPartnerExtra?.map((item: any) => {
                        const currentPath = location.pathname;
                        const hrefPath = String(item?.href || '').split('?')[0];
                        const hrefParts = hrefPath.split('/').filter(Boolean);
                        const agentFromHref = hrefParts[1] === 'dashboard' ? hrefParts[2] : undefined;
                        const isActive = agentFromHref
                            ? currentPath === hrefPath || currentPath.startsWith(`/dashboard/${agentFromHref}/`)
                            : location.pathname + location.search === item.href;

                        return (
                        <NavLink
                            key={item.name}
                            to={item.href}
                            onClick={onItemClick}
                            data-qa={`${(item?.name).toLowerCase().replaceAll(' ', '-')}`}
                            className={() =>
                                classNames(
                                    'text-base text-secondary group flex items-center hover:opacity-80 px-2 py-2 font-medium rounded-md mb-2',
                                    isActive
                                        ? 'bg-[#F5F5F5] dark:bg-black rounded-lg dark:text-white'
                                        : '',
                                )
                            }
                        >
                            {/* <item.icon className='mr-3 flex-shrink-0 h-6 w-6 text-indigo-300' aria-hidden='true' /> */}
                            <span className={'flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center'}>
                                {(item.iconActive || item.icon)}
                            </span>
                            <span className={classNames(
                                'text-base',
                                isActive ? 'font-medium' : '',
                            )}>
                                {item.name}
                            </span>
                        </NavLink>
                        );
                    })}
                </div>
            </>

        </div>
    );
};

export default Navigation;